"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var SupportForm = /*#__PURE__*/function (_window$AbstractEleme) {
    _inherits(SupportForm, _window$AbstractEleme);

    var _super = _createSuper(SupportForm);

    function SupportForm(id, options) {
      var _this2;

      _classCallCheck(this, SupportForm);

      _this2 = _super.call(this, id, options);
      _this2.$submit = _this2.$domElement.find('button[type="submit"]');
      _this2.$firstname = _this2.$domElement.find('[name="support[first_name]"]');
      _this2.$lastname = _this2.$domElement.find('[name="support[last_name]"]');
      _this2.$email = _this2.$domElement.find('[name="support[email]"]');
      _this2.$phone = _this2.$domElement.find('[name="support[phone]"]');
      _this2.$ordernumber = _this2.$domElement.find('[name="support[ordernumber]"]');
      _this2.$raffle = _this2.$domElement.find('[name="support[raffle]"]');
      return _this2;
    }

    _createClass(SupportForm, [{
      key: "init",
      value: function init() {
        var _this3 = this;

        var _this = this;

        var validatorRules = {
          'support[first_name]': {
            required: true,
            lettersonly: true
          },
          'support[last_name]': {
            required: true,
            lettersonly: true
          },
          'support[email]': {
            required: true,
            email: true
          },
          'support[phone]': {
            required: true
          },
          'support[ordernumber]': {
            required: {
              depends: function depends(element) {
                return _this3.$domElement.find("#support-form__radio-3").is(":checked") || _this3.$domElement.find("#support-form__radio-5").is(":checked");
              }
            }
          },
          'support[raffle]': {
            required: {
              depends: function depends(element) {
                return _this3.$domElement.find("#support-form__radio-8").is(":checked");
              }
            }
          }
        };
        var validatorMessages = {
          'support[first_name]': {
            lettersonly: this.$firstname.attr('data-lettersonly')
          },
          'support[last_name]': {
            lettersonly: this.$lastname.attr('data-lettersonly')
          }
        };
        this.$domElement.validate({
          rules: validatorRules,
          messages: validatorMessages,
          errorElement: 'small',
          errorClass: 'form-text',
          highlight: function highlight(element) {
            $(element).closest('.form-group').addClass('form-error');
          },
          unhighlight: function unhighlight(element) {
            $(element).closest('.form-group').removeClass('form-error');
          },
          submitHandler: function submitHandler(form) {
            try {
              _this.$domElement.find("#support-and-info__support__form-rafflename").add(_this.$domElement.find("#support-and-info__support__form-ordernumber")).each(function (i, el) {
                if ($(el).is(":hidden")) {
                  $(el).val(null);
                }
              });

              _this._killAJAXRequest();

              _this.AJAXrequest = $.ajax({
                type: "POST",

                /*url: _this.$domElement.attr("action"),*/
                // url: "https://ws.space23.it/support/mail/send",
                url: "https://ws.space23.it/zendesk/ticket/open",
                data: _this.$domElement.serialize(),
                success: function success(data) {
                  _this.reset();

                  $('input[type="radio"]').trigger("change");
                  $(window).triggerHandler(window.HelperModal.CLASSNAME + ".show", [{
                    theme: window.AbstractBootstrapModal.THEME_SUCCESS,
                    closeBtn: true,
                    body: 'Grazie per averci contattato. Ti risponderemo al più presto.'
                  }]);
                },
                error: function error(response) {
                  console.log('error:', response);
                  /*$(event.delegateTarget).removeAttr("disabled");
                  console.log("[EDIT ADDRESS ERROR]", response);*/

                  _this.reset();

                  $('input[type="radio"]').trigger("change");
                  $(window).triggerHandler(window.HelperModal.CLASSNAME + ".show", [{
                    theme: window.AbstractBootstrapModal.THEME_DANGER,
                    closeBtn: true,
                    body: 'Si è verificato un problema. Ti preghiamo di riprovare più tardi.'
                  }]);
                }
              });
            } catch (e) {
              _this.reset();

              $('input[type="radio"]').trigger("change");
              $(window).triggerHandler(window.HelperModal.CLASSNAME + ".show", [{
                theme: window.AbstractBootstrapModal.THEME_DANGER,
                closeBtn: true,
                body: 'Si è verificato un problema. Ti preghiamo di riprovare più tardi.'
              }]);
            }
          }
        });
        this.$dataRadioRel = this.$domElement.find("[data-radio-rel]").hide();
        this.$domElement.find('input[name="support-form__radio"]').on("change." + this.id, function (event) {
          var VAL = $(event.delegateTarget).attr("value");

          _this3.$dataRadioRel.hide();

          _this3.$dataRadioRel.filter(function (index, el) {
            return $(el).attr("data-radio-rel").match("support-form__radio-" + VAL);
          }).show();
        });
        this.$domElement.find('input[name="support-form__radio"]:checked').trigger("change");

        _get(_getPrototypeOf(SupportForm.prototype), "init", this).call(this);
      }
    }, {
      key: "reset",
      value: function reset() {
        this.$domElement[0].reset();
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this._killAJAXRequest();

        this.$submit = null;
        this.$firstname = null;
        this.$lastname = null;
        this.$email = null;
        this.$phone = null;
        this.$ordernumber = null;
        this.$raffle = null;

        _get(_getPrototypeOf(SupportForm.prototype), "dispose", this).call(this);
      }
    }, {
      key: "_killAJAXRequest",
      value: function _killAJAXRequest() {
        if (this.AJAXrequest) {
          this.AJAXrequest.abort();
          this.AJAXrequest = null;
        }
      }
    }]);

    return SupportForm;
  }(window.AbstractElement);

  window.SupportForm = SupportForm;
})(window);
